import { activeLanguage } from '../../activeLanguage';

export function isFrench(): boolean {
    return activeLanguage.locale.language === 'fr';
}